import React, { useState, useEffect, useContext, useRef } from "react";
import { useParams } from "react-router-dom";
import { Container, Row, Col } from "react-bootstrap";
import NavbarComp1 from "../components/Navbar1";
import { UserContext } from "../jsx/UserContext";
import api from "../jsx/axiosClient";
import Swal from "sweetalert2";
import ExpertAudioRedescribe from "../components/ExpertAudioRedescribe";
import ExpertAudioRedescribeVideo from "../components/ExpertAudioRedescribeVideo";
import AudioRedescribeChat from "../components/AudioRedescribeChat";
// import useWebSocketHandler from "../utils/WebSocketHandler";
// import useRedescribeHandler from "../utils/RedescribeHandler";
// import useChatHandler from "../utils/ChatHandler";
import {Form, Button, Card } from "react-bootstrap";
import { FaDownload, FaRedo, FaPaperPlane, FaArrowDown } from "react-icons/fa";
import { Tabs, Tab } from "react-bootstrap";
import Chatbot from "../components/Chatbot";
import AudioDescriptionEdit from "../components/AudioDescriptionEdit";
import Footer from "../components/Footer";

import withReactContent from "sweetalert2-react-content";

const VideoDescription = () => {

  const videoRef = useRef(null);
  const wsRef = useRef(null);
  const [isListening, setIsListening] = useState(false);
  const { id } = useParams(); // file_id from URL
  const { userSession } = useContext(UserContext);
  const [isRedescribing, setIsRedescribing] = useState(false);
  const [video, setVideo] = useState(null);
  const[redescribeVideodetails,setRedescribed_Videodetails] = useState(null);
  const [uniqueid, setUniqueId] = useState(null);
  const MySwal = withReactContent(Swal);
  const [progress, setProgress] = useState(0);
//const audioRecorderRef = useRef(null);
  const audioChunksRef = useRef([]);
  const [isAudioRecording, setIsAudioRecording] = useState(false);
  //const [recordingStartTime, setRecordingStartTime] = useState(null);
  const [recordingDuration, setRecordingDuration] = useState("00:00");
  const recordingTimerRef = useRef(null);
  const mediaRecorderRef = useRef(null); // to store MediaRecorder instance
  const [originalVideoUrl, setOriginalVideoUrl] = useState(null);
  const [activeTab, setActiveTab] = useState("described");
  const recordingStartTimeRef = useRef(null);
  // Form states
  const [stage, setStage] = useState(null);
  const recognitionRef = useRef(null);
  const [model, setModel] = useState("Amrita Model 1");
  const [videoname, setVideoname] = useState([]);
  const [videoDescription, setVideoDescription] = useState([]);

  const [language, setLanguage] = useState("English(US)");
  const [descriptionType, setDescriptionType] = useState("Brief");
  const [voice, setVoice] = useState("Male");
  const [mediaFormats, setMediaFormats] = useState([]);
  const [mediaFormatError, setMediaFormatError] = useState(false);

  const [messages, setMessages] = useState([]);
  const [input, setInput] = useState("");
  const [botTyping, setBotTyping] = useState(false);
  const [showScrollBtn, setShowScrollBtn] = useState(false);
  const messagesEndRef = useRef(null);
  const messagesContainerRef = useRef(null);
  const scrollToBottom = () => messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
//const isExpert  = userSession?.user_type === "expert";
const isExpert ="expert";

  useEffect(() => { if (!botTyping) scrollToBottom(); }, [messages, botTyping]);

  const formats = [
    { label: "Text (Transcript)", value: "text" },
    { label: "Audio", value: "audio" },
    { label: "Video (with embedded audio)", value: "video" },
  ];

 useEffect(() => {
    fetchVideoDetails();
  }, [id, userSession]);
const fetchVideoDetails = async () => {
      if (!userSession?.access_token) return;
      try {
        const response = await api.get(`/file/${id}`, {
          headers: { Authorization: `Bearer ${userSession.access_token}` },
        });
        const result = response.data;
        console.log("Video details:", result);
       setRedescribed_Videodetails(result);
        if (result.status === "success") {
          const fileData = result.data.file;
          const formData = result.data.form_data;
          console.log("unique_id", result.data.unique_id)
          setVideo({
            ...fileData,
            output_download_url: fileData.output_download_url
              ? (fileData.output_download_url.startsWith("http")
                ? fileData.output_download_url
                : `https://stagingapi.chalachitravaachana.org/${fileData.output_download_url}`)
              : null,
          });

          setOriginalVideoUrl(
            fileData.video_url?.startsWith("http")
              ? fileData.video_url
              : `https://stagingapi.chalachitravaachana.org/${fileData.video_url}`
          );
          setVideoname(fileData.name);
          setVideoDescription(formData.selected_description);
          setModel(formData.selected_model_key || "Amrita Model 1");
          setLanguage(formData.selected_language || "en-US");
          setDescriptionType(fileData.detail || "Brief");
          setVoice(formData.selected_narrator === "Male" ? "Male" : "Female"); // map if needed
          setMediaFormats(formData.selected_outputs || []);
          setUniqueId(result.data.unique_id);
          setStage(result.data.stage || "chat");
        } else {
          alert(result.message || "Failed to fetch video details");
        }
      } catch (error) {
        console.error("Error fetching video details:", error);
        alert("Server error: Could not fetch video details");
      }
    };

// useEffect(() => {
//     // APPLY STYLES ONLY WHEN THIS PAGE IS OPEN
//     document.body.style.overflow = "hidden";
//     document.getElementById("root").style.height = "100%";
//     document.getElementById("root").style.overflow = "hidden";

//     // Apply styles to container-fluid
//     const containers = document.querySelectorAll(".container-fluid");
//     containers.forEach((el) => {
//       el.style.flex = "1";
//       el.style.overflow = "auto";
//     });

//     // CLEANUP — REMOVE STYLES WHEN LEAVING THIS PAGE
//     return () => {
//       document.body.style.overflow = "";
//       document.getElementById("root").style.height = "";
//       document.getElementById("root").style.overflow = "";

//       containers.forEach((el) => {
//         el.style.flex = "";
//         el.style.overflow = "";
//       });
//     };
//   }, []);

// useEffect(() => {
//   // DO NOT BLOCK BODY SCROLL
//   document.body.style.overflow = "auto";

//   const root = document.getElementById("root");
//   root.style.height = "auto";
//   root.style.overflow = "visible";

//   // Apply scroll only to main content container
//   const containers = document.querySelectorAll(".container-fluid");
//   containers.forEach((el) => {
//     el.style.flex = "1";
//     el.style.overflowY = "auto";
//   });

//   return () => {
//     document.body.style.overflow = "";
//     root.style.height = "";
//     root.style.overflow = "";

//     containers.forEach((el) => {
//       el.style.flex = "";
//       el.style.overflow = "";
//     });
//   };
// }, []);


  const toggleFormat = (value) => {
    setMediaFormats((prev) => {
      const updated = prev.includes(value) ? prev.filter((f) => f !== value) : [...prev, value];
      setMediaFormatError(updated.length === 0);
      return updated;
    });
  };
  const handleChatStart = () => {
    if (videoRef.current && !videoRef.current.paused) {
      videoRef.current.pause();
    }
  };
  // Fetch video details on page load
  

  // useEffect(() => {
  //   const fetchVideoDetails = async () => {
  //     if (!userSession?.access_token) return;
  //     try {
  //       const response = await api.get(`/file/${id}`, {
  //         headers: { Authorization: `Bearer ${userSession.access_token}` },
  //       });
  //       const result = response.data;
  //       console.log("Video details:", result);
  //      setRedescribed_Videodetails(result);
  //       if (result.status === "success") {
  //         const fileData = result.data.file;
  //         const formData = result.data.form_data;
  //         console.log("unique_id", result.data.unique_id)
  //         setVideo({
  //           ...fileData,
  //           output_download_url: fileData.output_download_url
  //             ? (fileData.output_download_url.startsWith("http")
  //               ? fileData.output_download_url
  //               : `https://stagingapi.chalachitravaachana.org/${fileData.output_download_url}`)
  //             : null,
  //         });

  //         setOriginalVideoUrl(
  //           fileData.video_url?.startsWith("http")
  //             ? fileData.video_url
  //             : `https://stagingapi.chalachitravaachana.org/${fileData.video_url}`
  //         );
  //         setVideoname(fileData.name);
  //         setVideoDescription(formData.selected_description);
  //         setModel(formData.selected_model_key || "Amrita Model 1");
  //         setLanguage(formData.selected_language || "en-US");
  //         setDescriptionType(fileData.detail || "Brief");
  //         setVoice(formData.selected_narrator === "Male" ? "Male" : "Female"); // map if needed
  //         setMediaFormats(formData.selected_outputs || []);
  //         setUniqueId(result.data.unique_id);
  //         setStage(result.data.stage || "chat");
  //       } else {
  //         alert(result.message || "Failed to fetch video details");
  //       }
  //     } catch (error) {
  //       console.error("Error fetching video details:", error);
  //       alert("Server error: Could not fetch video details");
  //     }
  //   };

  //   fetchVideoDetails();
  // }, [id, userSession]);

  // Set default active tab based on whether audio-described video exists video tab showing
  useEffect(() => {
    if (video) {
      if (video.output_download_url) {
        setActiveTab("described"); // show audio described video if available
      } else {
        setActiveTab("original"); // fallback to uploaded video
      }
    }
  }, [video]);


  useEffect(() => {
    if (!uniqueid || !id || !userSession?.access_token) return;
    if (wsRef.current && wsRef.current.readyState === WebSocket.OPEN) {
      console.log("WebSocket already open");
      return;
    }
    const ws = new WebSocket(`wss://stagingapi.chalachitravaachana.org/ws/${uniqueid}/${id}`);
    wsRef.current = ws;
    ws.onopen = () => console.log("WebSocket connected (chat & redescribe)");
    ws.onmessage = (event) => {
      try {
        const data = JSON.parse(event.data);
        console.log("WebSocket message:", data);
        if (data.stage === "chat") {
          // Extract only the part after ':'
          const fullMessage = data.message || "";
          const messageParts = fullMessage.split(":");
          const textAfterColon = messageParts.length > 1 ? messageParts.slice(1).join(":").trim() : fullMessage;
          const botMessage = {
            sender: "bot",
            text: textAfterColon, // ✅ only message after ":"
            audio_url: `https://stagingapi.chalachitravaachana.org/${data.audio_url}` || null,
            time: new Date().toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" }),
          };
          setMessages((prev) => [...prev, botMessage]);
          setBotTyping(false);
        }
        else if (data.stage === "redescribe") {
          // ✅ Update progress bar
          if (data.progress_percent) setProgress(data.progress_percent);
          // ✅ Update video when done
          // 🔹 Update description list live while redescribing
if (data.message && data.timestamp) {
  setVideo((prev) => ({
    ...prev,
    descriptions: [
      ...(prev?.descriptions || []),
      {
        timestamp: data.timestamp,
        caption: data.message
      }
    ]
  }));
}

          if (data.progress_percent === "100" && data.output_download_url) {
            const updatedUrl = data.output_download_url.startsWith("http")
              ? data.output_download_url
              : `https://stagingapi.chalachitravaachana.org/${data.output_download_url}`;
            MySwal.fire({
              icon: "success",
              title: "Video Updated!",
              text: "Redescription successful. Your new video is ready.",
              showConfirmButton: false,
              timer: 2500,
            });

            setVideo((prev) => ({ ...prev, output_download_url: updatedUrl }));
            setIsRedescribing(false);
            setProgress(100);
            setTimeout(() => {
              if (videoRef.current) {
                videoRef.current.load();
                videoRef.current.play().catch((e) => console.warn("Autoplay blocked:", e));
              }
            }, 800);
          }
        }
      } catch (err) {
        console.error("WebSocket parse error:", err);
      }
    };
    ws.onerror = (err) => console.error("WebSocket error:", err);
    ws.onclose = () => console.log("WebSocket closed");
    return () => ws.close();
  }, [uniqueid, id, userSession]);

  const toggleAudioRecording = async () => {
    if (videoRef.current && !videoRef.current.paused) {
      videoRef.current.pause();
    }
    if (isAudioRecording) {
      mediaRecorderRef.current.stop();
      setIsAudioRecording(false);
      clearInterval(recordingTimerRef.current);
      setRecordingDuration("00:00");
    } else {
      if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
        Swal.fire({
          icon: "warning",
          text: "Microphone not supported!",
        });
        return;
      }
     // const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
let stream;
try {
  stream = await navigator.mediaDevices.getUserMedia({ audio: true });
} catch (err) {
  console.error("Mic permission error:", err);
  Swal.fire({
    icon: "error",
    title: "Microphone Permission Denied",
    text: "Please enable microphone access in your browser settings and try again.",
  });
  return;
}

      const mediaRecorder = new MediaRecorder(stream);
      mediaRecorderRef.current = mediaRecorder;
      audioChunksRef.current = [];
      mediaRecorder.ondataavailable = (e) => {
        audioChunksRef.current.push(e.data);
      };
      recordingStartTimeRef.current = Date.now();
      recordingTimerRef.current = setInterval(() => {
        const elapsed = Date.now() - recordingStartTimeRef.current;
        const seconds = Math.floor(elapsed / 1000) % 60;
        const minutes = Math.floor(elapsed / 60000);
        setRecordingDuration(
          `${minutes.toString().padStart(2, "0")}:${seconds
            .toString()
            .padStart(2, "0")}`
        );
      }, 1000);

      mediaRecorder.onstop = async () => {
        const audioBlob = new Blob(audioChunksRef.current, { type: "audio/webm" });
        const audioUrl = URL.createObjectURL(audioBlob);
        const timeNow = new Date().toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
        console.log("audioUrl:", audioUrl)
        console.log("timeNow:", timeNow)
        const video = videoRef.current;
        clearInterval(recordingTimerRef.current);
        setRecordingDuration("00:00");
        setIsAudioRecording(false);
        const timestamp = video.currentTime;
        console.log("Current video timestamp:", timestamp);
        setMessages((prev) => [
          ...prev,
          { sender: "user", audio_url: audioUrl, time: timeNow }
        ]);
        setInput("");
        setBotTyping(true);
        try {
          const audiodata = {
            audio: audioBlob,
            video_id: id,
            timestamp: timestamp,
            c_language: language,
            c_gender: voice
          };
          console.log("chatbot data for API call", audiodata)
          await api.post("/chat/audio", audiodata, {
            headers: { Authorization: `Bearer ${userSession.access_token}` },
          });

        } catch (err) {
          console.error("Audio upload error:", err);
          setMessages((prev) => [
            ...prev,
            {
              sender: "bot",
              text: "❌ Failed to send audio. Please try again.",
              time: timeNow,
            },
          ]);
          setBotTyping(false);
        }
      };
      mediaRecorder.start();
      setIsAudioRecording(true);
      setTimeout(() => {
        if (mediaRecorder.state !== "inactive") {
          console.log("⏹ Stopping after 10 seconds");
          mediaRecorder.stop();
        }
      }, 10000);

    }
  };

  const handleRedescribe = async () => {
    if (!userSession?.access_token) {
      Swal.fire({
        icon: "warning",
        title: "Session Expired",
        text: "Please log in again.",
      });
      return;
    }
    if (mediaFormats.length === 0) {
      setMediaFormatError(true);
      Swal.fire({
        icon: "info",
        title: "Select Format",
        text: "Please select at least one output format before redescribing.",
      });
      return;
    }
    setIsRedescribing(true);
    setProgress(0);
    try {
      const requestData = {
        video_id: id,
        model,
        language,
        detail: descriptionType,
        voice,
        format: JSON.stringify(mediaFormats),
        unique_id: uniqueid, 
      };

      console.log("Redescribe request:", requestData);
      // ✅ Step 2: Open WebSocket connection before calling API
      const ws = wsRef.current || new WebSocket(`wss://stagingapi.chalachitravaachana.org/ws/${uniqueid}/${id}`);
      if (!wsRef.current) wsRef.current = ws;
      ws.onopen = () => {
        console.log("WebSocket connected");
      };
      ws.onmessage = (event) => {
        try {
          const data = JSON.parse(event.data);
          console.log("WebSocket message:", data);
          if (data.progress_percent) {
            setProgress(data.progress_percent);
          }
          // ✅ When processing is done and output URL received
          if (data.progress_percent == "100" && data.output_download_url) {
            const updatedVideoUrl = data.output_download_url.startsWith("http")
              ? data.output_download_url
              : `https://stagingapi.chalachitravaachana.org/${data.output_download_url}`;
            MySwal.fire({
              icon: "success",
              title: "Video Updated!",
              text: "Redescription successful. Your new video is ready.",
              showConfirmButton: false,
              timer: 1000,
            });
            setVideo((prev) => ({
              ...prev,
              output_download_url: updatedVideoUrl,
            }));
            setIsRedescribing(false);
            setProgress(100);
            //  ws.close();
                          fetchVideoDetails();   // ✅ THIS UPDATES VIDEO + DESCRIPTIONS

            setTimeout(() => {
              if (videoRef.current) {
                videoRef.current.load();
                videoRef.current.play().catch((e) => console.warn("Autoplay blocked:", e));
              }
            }, 800);
          }
        } catch (err) {
          console.error("WebSocket message error:", err);
        }
      };
      ws.onerror = (error) => {
        console.error("WebSocket error:", error);
        Swal.fire({
          icon: "error",
          title: "Connection Error",
          text: "WebSocket connection failed.",
        });
        setIsRedescribing(false);
      };
      ws.onclose = () => console.log("WebSocket closed");
      const response = await api.post("/redescribe-user-file", requestData, {
        headers: { Authorization: `Bearer ${userSession.access_token}` },
      });
      console.log("Redescribe response:", response.data);
      if (response.data.status !== "success") {
        Swal.fire({
          icon: "warning",
          title: "Failed",
          text: response.data.message || "Could not redescribe video.",
        });
        setIsRedescribing(false);
        ws.close();
      }
    } catch (error) {
      console.error("Error redescribing video:", error);
      Swal.fire({
        icon: "error",
        title: "Server Error",
        text: "Could not redescribe video.",
      });
      setIsRedescribing(false);
    }
  };

const handleExport = async (type) => {
  console.log("handleExport Received type:", type);

  if (!userSession?.access_token) {
    Swal.fire({
      icon: "warning",
      title: "Session Expired",
      text: "Please log in again.",
    });
    return;
  }

  let apiUrl = "";
  let fileName = "";
  let fileExtension = "";

switch (type.toLowerCase()) {
    case "uploadedvideo":
      apiUrl = `https://stagingapi.chalachitravaachana.org/${video.video_url}`;
      fileExtension = ".mp4";
      fileName = video.name || "uploaded_video";
      console.log("download url", apiUrl)
      console.log("fileName",fileName)
      break;

    case "text":
      apiUrl = `https://stagingapi.chalachitravaachana.org/${video.text_url}`;
      fileExtension = ".txt";
      fileName = video.name || "transcript";
      console.log("download url", apiUrl)
      console.log("fileName",fileName)
      break;

    case "audio":
      apiUrl = `https://stagingapi.chalachitravaachana.org/${video.audio_url}`;
      fileExtension = ".wav"; // or ".mp3" based on your audio format
      fileName = video.name || "audio_clip";
      console.log("download url", apiUrl)
      console.log("fileName",fileName)
      break;

case "video": // redescribed video
  if (!video?.output_download_url) {
    Swal.fire({
      icon: "warning",
      title: "Audio Described Video Not Available",
    //  text: "Audio.",
    });
    return;
  }
  apiUrl = video.output_download_url.startsWith("http")
    ? video.output_download_url
    : `https://stagingapi.chalachitravaachana.org/${video.output_download_url}`;
  fileExtension = ".mp4";
  fileName = video.name || "redescribed_video";
  break;

    default:
      Swal.fire({
        icon: "error",
        title: "Unknown Export Type",
        text: "Invalid download request.",
      });
      return;
  }

  console.log("Final Download URL:", apiUrl);

const downloadFileDirect = async (url, filename) => {   // download for server
  const response = await fetch(url);
  const blob = await response.blob();
  const blobUrl = window.URL.createObjectURL(blob);

  const link = document.createElement("a");
  link.href = blobUrl;
  link.download = filename;
  link.click();

  window.URL.revokeObjectURL(blobUrl);
};

try {
  Swal.fire({
    icon: "success",
    title: "Download Successful",
    timer: 1500,
    showConfirmButton: false,
  });

  downloadFileDirect(apiUrl, `${fileName}${fileExtension}`);

} catch (err) {
  console.error(err);
  Swal.fire({
    icon: "error",
    title: "Download Failed",
    text: "Could not download the file.",
  });
}

};


const handleExportcrt = async (type) => {
  console.log("handleExport Received type:", type);
  if (!userSession?.access_token) {
    Swal.fire({
      icon: "warning",
      title: "Session Expired",
      text: "Please log in again.",
    });
    return;
  }
  if (!video?.output_download_url) {
    Swal.fire({
      icon: "info",
      title: "No Video Available",
      text: "Please redescribe or upload a video before exporting.",
    });
    return;
 }
const uploaded_video_url =  `https://stagingapi.chalachitravaachana.org/${video.video_url}`;

  console.log("uploaded_video_url:", uploaded_video_url);

  const finalUrl = video.output_download_url.startsWith("http")
    ? video.output_download_url
    : `https://stagingapi.chalachitravaachana.org/${video.output_download_url}`;
console.log("finalUrl",finalUrl)
 

  try {
    Swal.fire({
      title: 'Downloading...',
      html: 'Progress: <b>0%</b>',
      didOpen: () => Swal.showLoading(),
      allowOutsideClick: false,
      showConfirmButton: false,
    });

  
  const downloadurl = { video_url: finalUrl};
      console.log("download API data", downloadurl)
       const response = await api.post("/download", downloadurl, {
        headers: { Authorization: `Bearer ${userSession.access_token}` },
        responseType: "blob",
      });
console.log("response",response)
const blob = new Blob([response.data], { type: "video/mp4" });
const link = document.createElement("a");
link.href = window.URL.createObjectURL(blob);
link.download = `${video.name || "exported_video"}.mp4`;
link.click();

    Swal.fire({
      icon: "success",
      title: "Download Successful",
      timer: 2000,
      showConfirmButton: false,
    });

  } catch (err) {
    console.error(err);
    Swal.fire({
      icon: "error",
      title: "Download Failed",
      text: "There was an issue downloading the video.",
    });
  }
};

  const handleSend = async () => {
    if (!input.trim()) return;
    const video = videoRef.current;
    const timestamp = video.currentTime;
    console.log("Current video timestamp:", timestamp);
    const userMessage = {
      sender: "user",
      text: input,
      time: new Date().toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" }),
    };
    setMessages((prev) => [...prev, userMessage]);
    setInput("");
    setBotTyping(true);
    try {
      const payload = { message: input, video_id: id, timestamp: timestamp, c_language: language, c_gender: voice };
      console.log("chatbot data for API call", payload)
      await api.post("/chat", payload, {
        headers: { Authorization: `Bearer ${userSession.access_token}` },
      });
      // ✅ Do NOT add bot reply here — WebSocket will push server reply
    } catch (error) {
      console.error("Chatbot API error:", error);
      const errorMsg = {
        sender: "bot",
        text: "Server error: Please try again later.",
        time: new Date().toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" }),
      };
      setMessages((prev) => [...prev, errorMsg]);
      setBotTyping(false);
    }
  };


  const handleKeyPress = (e) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      handleSend();
    }
  };

  const handleScroll = () => {
    if (!messagesContainerRef.current) return;
    const { scrollTop, scrollHeight, clientHeight } = messagesContainerRef.current;
    setShowScrollBtn(scrollTop + clientHeight < scrollHeight - 50);
  };

  return (
   <div className="page-wrapper" role="application">
<a href="#maincontent" className="sr-only sr-only-focusable">
    Skip to main content
  </a>
          <div className="content-wrapper">
    <div className="main-div" id="maincontent"
     role="main"
      tabIndex="-1"
      aria-label="Audio redescribe workspace"
    >
      <NavbarComp1 />
      <Container fluid className="py-2 redescribe-form">
  {/* Screen reader heading */}
        <h1 className="sr-only">Audio Redescribe Dashboard</h1>
        <Row>

   <Col md={12} role="region" aria-labelledby="videoHeading">
            <h2 id="videoHeading" className="sr-only">
              Video preview and timeline
            </h2>
            <ExpertAudioRedescribeVideo
              video={video}
              originalVideoUrl={originalVideoUrl}
              activeTab={activeTab}
              setActiveTab={setActiveTab}
              videoRef={videoRef}
               videoname={videoname}
            setVideoname={setVideoname}


videoDescription={videoDescription}
            setVideoDescription={setVideoDescription}
            model={model}
              setModel={setModel}
              language={language}
              setLanguage={setLanguage}
              descriptionType={descriptionType}
              setDescriptionType={setDescriptionType}
              voice={voice}
              setVoice={setVoice}
              mediaFormats={mediaFormats}
              mediaFormatError={mediaFormatError}
              toggleFormat={toggleFormat}
              handleRedescribe={handleRedescribe}
              isRedescribing={isRedescribing}
              progress={progress}
              handleExport={handleExport}
              redescribeVideodetails= {redescribeVideodetails}

            isExpert ={isExpert }
            
            />
          </Col>

{/* 
          <Col md={4} role="region" aria-labelledby="formHeading">
          <h2 id="formHeading" className="sr-only">
              Audio description settings
            </h2>
            <ExpertAudioRedescribe
            videoname={videoname}
            setVideoname={setVideoname}
            videoDescription={videoDescription}
            setVideoDescription={setVideoDescription}
            model={model}
              setModel={setModel}
              language={language}
              setLanguage={setLanguage}
              descriptionType={descriptionType}
              setDescriptionType={setDescriptionType}
              voice={voice}
              setVoice={setVoice}
              mediaFormats={mediaFormats}
              mediaFormatError={mediaFormatError}
              toggleFormat={toggleFormat}
              handleRedescribe={handleRedescribe}
              isRedescribing={isRedescribing}
              progress={progress}
              handleExport={handleExport}
              redescribeVideodetails= {redescribeVideodetails}
               video={video}
  videoRef={videoRef}
            />

              
          </Col> */}
       

        </Row>
  {/* Chatbot region */}
        <section
          role="region"
          aria-labelledby="chatHeading"
          aria-live="polite"
        >
          <h2 id="chatHeading" className="sr-only">
            Assistant chat
          </h2>

         <Chatbot
           messages={messages}
              botTyping={botTyping}
              input={input}
              setInput={setInput}
              isAudioRecording={isAudioRecording}
              toggleAudioRecording={toggleAudioRecording}
              recordingDuration={recordingDuration}
              showScrollBtn={showScrollBtn}
              scrollToBottom={scrollToBottom}
              handleSend={handleSend}
              messagesContainerRef={messagesContainerRef}
              messagesEndRef={messagesEndRef}
              handleScroll={handleScroll}
              handleKeyPress={handleKeyPress}
              handleChatStart={handleChatStart} />


      </section>
      </Container>
  <Footer />


    </div></div></div>
  );
};

export default VideoDescription;

